'use memo';

import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { useCallback, useEffect, useMemo } from 'react';
import NSWAgreementDetailsStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/NSW/NSWAgreementDetailsStageSteps';
import { TaskModalPageProps } from '../TaskModalPageProps';

const NswAgreementDetails = ({
  task,
  taskNumber,
  toggleTaskStep,
  agreementDetails,
  onAgreementDetailsUpdated,
}: TaskModalPageProps) => {
  const taskSteps = useMemo(() => task.taskSteps ?? [], [task.taskSteps]);

  useEffect(() => {
    const startStep = taskSteps.find((step) => step.order === 7);
    const endStep = taskSteps.find((step) => step.order === 8);

    if (startStep && startStep.isCompleted !== Boolean(agreementDetails?.startDate)) {
      toggleTaskStep(startStep.order ?? 0, Boolean(agreementDetails?.startDate));
    }

    if (endStep && endStep.isCompleted !== Boolean(agreementDetails?.endDateExclusive)) {
      toggleTaskStep(endStep.order ?? 0, Boolean(agreementDetails?.endDateExclusive));
    }
  }, [agreementDetails, taskSteps, toggleTaskStep]);

  const updateTaskStep = useCallback(
    (step: { order?: number }, isChecked: boolean) => {
      toggleTaskStep(step.order ?? 0, isChecked);
    },
    [toggleTaskStep]
  );

  if (!onAgreementDetailsUpdated) {
    return null;
  }

  return (
    <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
      <AgxTypography size="large" type="label" id="step1title" color="var(--text-primary)">
        {`Step ${taskNumber}: Agreement Compliance`}
      </AgxTypography>
      <NSWAgreementDetailsStageSteps
        agreementDetails={agreementDetails}
        onAgreementDetailsUpdated={onAgreementDetailsUpdated}
        isOpen={false}
        exceededGap={false}
        tasksStage={taskSteps}
        updateTaskStep={updateTaskStep}
      />
    </AgxSpacer>
  );
};

export default NswAgreementDetails;
